import {
  TransactionStateType,
  TransactionState,
} from "@hl/shared-features/lib/features/evm-tx/TransactionContext";
import { networkLookup } from "@hl/shared-features/lib/utils/blockExplorer";

export const transactionStateErrorMsg = (
  transactionState?: TransactionState
) => {
  if (!transactionState) {
    return;
  }
  const txType = transactionState.type;

  if (txType === TransactionStateType.ChainSwitchError) {
    return `Failed to switch to chain ${switchToChain(transactionState)}`;
  }
};

const switchToChain = (transactionState: TransactionState) => {
  const { chainId } = transactionState;
  if (!chainId) return "";
  return `${networkLookup(chainId)?.displayName} (chain ID ${chainId})`;
};
